import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { tokens as c } from '../../theme/tokens';

/**
 * An empty list or table: an icon on a tinted circle, one sentence that says
 * why it is empty, and at most one button that fixes it. Use instead of a
 * bare "Emptylist" / "No data".
 *
 *   <EmptyState icon={<EventBusyOutlinedIcon />} title="No trips between 14 Oct and 24 Oct"
 *               actionLabel="Show all trips" onAction={clearDates} />
 */
export default function EmptyState({ icon, title, body, actionLabel, onAction, compact = false, sx }) {
  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1.5,
        py: compact ? 3 : 6,
        px: 2,
        ...sx,
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          width: compact ? 48 : 64,
          height: compact ? 48 : 64,
          borderRadius: '50%',
          bgcolor: c.ACCENT_TINT,
          color: c.ACCENT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiSvgIcon-root': { fontSize: compact ? 22 : 28 },
        }}
      >
        {icon || <InboxOutlinedIcon />}
      </Box>
      {title ? (
        <Typography component="p" sx={{ fontSize: 17, fontWeight: 500, lineHeight: 1.45, color: c.INK, maxWidth: 480 }}>
          {title}
        </Typography>
      ) : null}
      {body ? (
        <Typography component="p" variant="body2" sx={{ color: c.INK_2, maxWidth: 480 }}>
          {body}
        </Typography>
      ) : null}
      {actionLabel && typeof onAction === 'function' ? (
        <Button variant="contained" onClick={onAction} sx={{ mt: 0.5 }}>
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}
